import { ResponsiveContainer, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, Legend } from 'recharts';

const CHART_TICK = { fontSize: 12, fill: '#78716c' };
const TOOLTIP_STYLE = { borderRadius: '8px', border: '1px solid #e7e5e4' };

export const FnBChart = ({ data, formatCurrency }) => (
  <div className="lg:col-span-2 bg-white border border-stone-200 rounded-md p-6">
    <h3 className="font-semibold text-stone-900 font-['Manrope'] mb-4">Top Selling Items</h3>
    {data?.top_items?.length > 0 ? (
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data.top_items} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" stroke="#e7e5e4" />
          <XAxis type="number" tick={CHART_TICK} />
          <YAxis type="category" dataKey="name" tick={CHART_TICK} width={120} />
          <Tooltip
            formatter={(value, name) => [name === 'revenue' ? formatCurrency(value) : value, name === 'revenue' ? 'Revenue' : 'Quantity']}
            contentStyle={TOOLTIP_STYLE}
          />
          <Legend />
          <Bar dataKey="quantity" name="Quantity" fill="#7c3aed" radius={[0, 4, 4, 0]} />
          <Bar dataKey="revenue" name="Revenue" fill="#c2410c" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    ) : (
      <div className="flex items-center justify-center h-[300px] text-stone-500">No F&B data available</div>
    )}
  </div>
);

export const FnBSummary = ({ data, formatCurrency }) => (
  <div className="bg-white border border-stone-200 rounded-md p-6">
    <h3 className="font-semibold text-stone-900 font-['Manrope'] mb-4">F&B Summary</h3>
    <div className="space-y-4">
      <div className="p-4 bg-stone-50 rounded-md">
        <p className="text-sm text-stone-500">Total Orders</p>
        <p className="text-2xl font-bold text-stone-900 font-['Manrope']">{data?.summary?.total_orders || 0}</p>
      </div>
      <div className="p-4 bg-stone-50 rounded-md">
        <p className="text-sm text-stone-500">Total Revenue</p>
        <p className="text-2xl font-bold text-sage-700 font-['Manrope']">{formatCurrency(data?.summary?.total_revenue || 0)}</p>
      </div>
      <div className="p-4 bg-stone-50 rounded-md">
        <p className="text-sm text-stone-500">Avg. Order Value</p>
        <p className="text-2xl font-bold text-emerald-700 font-['Manrope']">{formatCurrency(data?.summary?.average_order_value || 0)}</p>
      </div>
    </div>
    {data?.orders_by_status?.length > 0 && (
      <div className="mt-6 pt-4 border-t border-stone-100">
        <h4 className="text-sm font-medium text-stone-700 mb-3">Orders by Status</h4>
        <div className="space-y-2">
          {data.orders_by_status.map((item) => (
            <div key={item.status} className="flex items-center justify-between text-sm">
              <span className="text-stone-600 capitalize">{item.status}</span>
              <span className="font-medium text-stone-900">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    )}
  </div>
);
